import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useIsOverflow } from '../../../../../../../../../../hooks/useIsOverflow';
import { getStatusText } from '../../../../../../ShareDrawer/utils';
import {
  StyledOverflowTextAttributeDiv,
  popoverStyle,
} from '../../../../../utility/compareDrawer.styled';
import {
  ATTRIBUTE_STATUS_TEXT,
  NULL_ATTRIBUTE_STATE,
} from '../../../../../utility/compareDrawerConstants';

type Props = {
  hasEveningAppointments: boolean;
  mobile: boolean;
};

export const OffersEveningAppointments = ({
  hasEveningAppointments,
  mobile,
}: Props) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const isOverflow = useIsOverflow(containerRef);

  const offerEveningAppointmentsText = t(
    getStatusText(
      hasEveningAppointments,
      ATTRIBUTE_STATUS_TEXT.OFFERS_EVENING_APPOINTMENTS.TRUE,
      ATTRIBUTE_STATUS_TEXT.OFFERS_EVENING_APPOINTMENTS.FALSE,
      NULL_ATTRIBUTE_STATE.OFFERS_EVENING_APPOINTMENTS
    )
  );

  const isAttributeEmpty =
    offerEveningAppointmentsText ===
    NULL_ATTRIBUTE_STATE.OFFERS_EVENING_APPOINTMENTS;

  const OffersEveningAppointments = (
    <StyledOverflowTextAttributeDiv
      cssProps={{ isOverflow, isAttributeEmpty }}
      ref={containerRef}
    >
      {hasEveningAppointments ? (
        <Layout.Group space={4}>
          <IconBrand
            data-testid="offers-evening-appointment-icon"
            icon="moon"
            size={20}
            variant="twotone"
          />
          {offerEveningAppointmentsText}
        </Layout.Group>
      ) : (
        offerEveningAppointmentsText
      )}
    </StyledOverflowTextAttributeDiv>
  );

  if (mobile) {
    return (
      <React.Fragment>
        {isOverflow ? (
          <Popover
            content={offerEveningAppointmentsText}
            css={popoverStyle}
            showClose={false}
            tabIndex="-1"
            width={150}
          >
            {OffersEveningAppointments}
          </Popover>
        ) : (
          OffersEveningAppointments
        )}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {isOverflow ? (
        <Tooltip content={offerEveningAppointmentsText} position="top">
          {OffersEveningAppointments}
        </Tooltip>
      ) : (
        OffersEveningAppointments
      )}
    </React.Fragment>
  );
};
